module.exports = __webpack_public_path__ + "img/app-2.85841943.png";